import type { Faq } from '../entities/faq.entity'
import type { FaqRepository } from '../repositories/faq_repository'

export class ListFaqsUseCase {
  constructor(private readonly repository: FaqRepository) {}

  execute(): Promise<Faq[]> {
    return this.repository.list()
  }
}
